<template>
  <a-modal
    class="company-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    title="关联医生"
    @cancel="$emit('onCancel')"
  >
    <a-table
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.id"
      :pagination="false"
    />
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
        },
        {
          title: '医生昵称',
          dataIndex: 'user_nickname',
        },
        {
          title: '医生姓名',
          dataIndex: 'user_realname',
        },
      ],
    };
  },
  mounted() {},
  methods: {
  },
};
</script>
<style lang="scss" scoped>

</style>